import { render, staticRenderFns } from "./subcon-mapping.vue?vue&type=template&id=61fd2394&scoped=true"
import script from "./subcon-mapping.vue?vue&type=script&lang=js"
export * from "./subcon-mapping.vue?vue&type=script&lang=js"
import style0 from "./subcon-mapping.vue?vue&type=style&index=0&id=61fd2394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd2394",
  null
  
)

export default component.exports